export default "__VITE_ASSET__D2oypyXR__"